import {
  AssetType,
  TradeControllerVariants,
  TradeOperation,
} from '../../utils/reusableTypes';
import { AppUserFullInfo } from '@bts-web/core-features/common';

const appropriatenessCheckOperations: TradeControllerVariants[] = [
  'buy',
  'savings',
  'swap',
  'order',
];

type AppropriatenessStatus = Pick<
  AppUserFullInfo,
  | 'appropriatenessRequiresTestCompletion'
  | 'appropriatenessRequiresTestResubmission'
>;

interface AppropriatenessCheckParams {
  assetType: string;
  operation?: string;
  assetId?: string;
  searchParams?: Record<string, string>;
  appropriatenessStatus: AppropriatenessStatus;
}

export const getAppropriatenessRedirectUrl = ({
  assetType,
  operation,
  assetId,
  searchParams,
  appropriatenessStatus,
}: AppropriatenessCheckParams): string | null => {
  if (
    !operation ||
    !appropriatenessCheckOperations.includes(
      operation as TradeControllerVariants,
    )
  ) {
    return null;
  }

  const isSecurityAsset = [AssetType.ETC, AssetType.ETF, AssetType.STOCK].some(
    (item) => item === assetType,
  );

  const {
    appropriatenessRequiresTestCompletion,
    appropriatenessRequiresTestResubmission,
  } = appropriatenessStatus;

  if (
    !isSecurityAsset ||
    (!appropriatenessRequiresTestCompletion &&
      !appropriatenessRequiresTestResubmission)
  ) {
    return null;
  }

  let url = `/appropriateness-questions/introduction?assetId=${encodeURIComponent(assetId || '')}&next=${encodeURIComponent(operation)}`;

  if (operation === TradeOperation.swap && searchParams?.swapWith) {
    url = `${url}&swapWith=${encodeURIComponent(searchParams.swapWith)}`;
  }

  return url;
};
